import { useEffect, useMemo, useState } from "react";
import { Film } from "lucide-react";
import { resolveVideo } from "../lib/video";

export const VideoPreview = ({ mode, file, sourceType, url, current }) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (mode === "upload" && file) {
      const u = URL.createObjectURL(file);
      setBlobUrl(u);
      return () => URL.revokeObjectURL(u);
    }
    setBlobUrl(null);
  }, [mode, file]);

  // A pending selection = a local file (upload) or a typed URL (link).
  const hasSelection = (mode === "upload" && !!blobUrl) || (mode === "link" && !!url);

  // What to actually preview: the pending selection, otherwise the currently published video.
  const previewSrc = useMemo(() => {
    if (mode === "upload" && blobUrl) return { kind: "video", src: blobUrl };
    if (mode === "link" && url) return resolveVideo(sourceType, url);
    if (current?.published) return resolveVideo(current.source_type, current.url);
    return { kind: "none" };
  }, [mode, blobUrl, url, sourceType, current]);

  const label = hasSelection ? "Prévia do novo vídeo" : current?.published ? "Vídeo atual publicado" : "Prévia do vídeo";

  return (
    <div>
      <p className="mb-2 flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-muted-foreground">
        <Film className="h-3.5 w-3.5" /> {label}
      </p>
      <div
        data-testid="video-preview"
        className="aspect-video w-full overflow-hidden rounded-xl border border-border bg-black"
      >
        {previewSrc.kind === "video" && (
          <video data-testid="video-preview-player" src={previewSrc.src} controls className="h-full w-full" />
        )}
        {previewSrc.kind === "iframe" && (
          <iframe
            data-testid="video-preview-player"
            src={previewSrc.src}
            title="Prévia"
            className="h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
        {previewSrc.kind === "link" && (
          <div className="flex h-full w-full items-center justify-center px-4 text-center text-sm text-slate-300">
            Link válido — a prévia embutida não está disponível, mas ele abrirá para quem escanear.
          </div>
        )}
        {previewSrc.kind === "none" && (
          <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-slate-500">
            <Film className="h-8 w-8" />
            <span className="text-sm">
              {mode === "upload" ? "Selecione um arquivo para ver a prévia" : "Cole um link para ver a prévia"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
